<template>
    <small class="mei-formset-accordion-label muted block ion-margin-top">Quantità</small>
    <div class="mei-formset-accordion-segment ion-margin-top-half">
        <ion-segment :value="quantity" @ionChange.prevent.stop="$emit('update:quantity', $event.target.value)">
            <ion-segment-button tabindex="-1" :value="IndoorFlyingTrapAuditQuantity.exceeding" style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>
                    Oltre {{ captureLimitUpper }}
                </ion-label>
            </ion-segment-button>
            <ion-segment-button tabindex="-1" :value="IndoorFlyingTrapAuditQuantity.medium" style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>
                    {{ captureLimitUpper }} -
                    {{ captureLimitLower }}
                </ion-label>
            </ion-segment-button>
            <ion-segment-button tabindex="-1" :value="IndoorFlyingTrapAuditQuantity.inferior" style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>
                    {{ captureLimitLower }} - 0
                </ion-label>
            </ion-segment-button>
        </ion-segment>
    </div>

    <div class="mei-formset-accordion-field-group ion-margin-top">
        <small class="mei-formset-accordion-label muted">Limiti di accettabilità</small>
        <span class="mei-formset-accordion-label-content">
            {{ captureLimitAcceptabilityLimits }}
        </span>
    </div>
    <div class="mei-formset-accordion-field-group ion-margin-top">
        <ion-textarea class="mei-input mei-note-input"
                      :value="note" @input="$emit('update:note', $event.target.value)" label="Note"
                      label-placement="stacked" tabindex="-1"></ion-textarea>
    </div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import {IndoorFlyingTrapAuditQuantity} from "@/types/audit";
import {IonLabel, IonSegment, IonSegmentButton, IonTextarea} from "@ionic/vue";

defineProps({
    captureLimitLower: {
        type: Number,
        required: true,
    },
    captureLimitUpper: {
        type: Number,
        required: true,
    },
    captureLimitAcceptabilityLimits: {
        type: String,
        required: true,
    },
    note: {
        type: String,
        required: true,
    },
    quantity: {
        type: String as PropType<IndoorFlyingTrapAuditQuantity>,
        required: true,
    }
});
defineEmits(['update:note', 'update:quantity']);
</script>
